/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '../../../utils/format';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/koordinator-laporan?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/koordinator-laporan/${payload.id}`).then(({ data }) => data);
  },

  create({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/koordinator-laporan/create`, payload.params).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/koordinator-laporan/${payload.id}/update`, payload.params).then(({ data }) => data);
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/koordinator-laporan/${payload.id}/delete`).then(({ data }) => data);
  },

  uploadBerkas({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/koordinator-laporan/${payload.koordinatorId}/berkas-insert`, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  deleteBerkas({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/koordinator-laporan/${payload.koordinatorId}/berkas-delete/${payload.id}`);
  },

  cekRekaman({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.get(`/psp/i/${id}/koordinator-laporan/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },
};
